const LINK_POPUP_SIDE_PADDING_PX = 10;
const LINK_POPUP_BOTTOM_PADDING_PX = 10;
const LINK_POPUP_MIN_TOP_OFFSET_PX = 60;
const LINK_POPUP_CONTENT_GAP_PX = 0;

export function calculatePopupCoordinates(
    coordinates: { top: number; left: number },
    wrapperRect: DOMRect,
    canvasRect: DOMRect,
): { left: number; top: number } {
    let left = Math.round(coordinates.left - wrapperRect.width / 2);
    let top = Math.round(coordinates.top + LINK_POPUP_CONTENT_GAP_PX);

    const minLeft = canvasRect.left + LINK_POPUP_SIDE_PADDING_PX;
    const maxLeft = Math.max(
        minLeft,
        canvasRect.right - wrapperRect.width - LINK_POPUP_SIDE_PADDING_PX,
    );
    const minTop = canvasRect.top + LINK_POPUP_MIN_TOP_OFFSET_PX;
    const maxTop = Math.max(
        minTop,
        canvasRect.bottom - wrapperRect.height - LINK_POPUP_BOTTOM_PADDING_PX,
    );

    if (left < minLeft) {
        left = minLeft;
    } else if (left > maxLeft) {
        left = maxLeft;
    }

    if (top < minTop) {
        top = minTop;
    } else if (top > maxTop) {
        top = maxTop;
    }

    return { left, top };
}
